var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bars"},_vm._l((3),function(i){return _c('div',{key:i,staticClass:"bar",style:(_vm.barStyle(i))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }